import React, { useEffect } from 'react';
import { PageHeader } from '../../../../common/index'
import { useNavigationContext } from '../../../../context/NavigationContext';
import { useDashboardAssociationContext } from '../../../../context/DashboardAssociationContext';
import Webbshop from '../../Webbshop';
import AssociationSales from './AssociationSales';

const DashboardAssociationHome = () => {
  const {
    associationId,
    associationData,
    associationBooklets,
    shopShareDomain,
    selectedBooklet,
    setSelectedBooklet,
    defaultBooklet,
  } = useDashboardAssociationContext();
  const { setNavigationActivated } = useNavigationContext();

  // Kontrollera om denna association är huvudföreningen för häftet
  const isMainAssociation = selectedBooklet?.mainAssociationId === associationId;

  useEffect(() => {
    setNavigationActivated(true);
  }, [setNavigationActivated]);

  // Sätt defaultBooklet om ingen är vald
  useEffect(() => {
    if (defaultBooklet && !selectedBooklet) {
      setSelectedBooklet(defaultBooklet);
    }
  }, [defaultBooklet, selectedBooklet, setSelectedBooklet]);

  return (
    <div id="dashboard" className='start'>
      <PageHeader>
        <h1>Hej {associationData?.name}!</h1>
        <p>Välkommen till Mina sidor.</p>
      </PageHeader>
      <Webbshop
        association={associationData!}
        shopShareDomain={shopShareDomain}
      />
      <AssociationSales
        associationId={associationId}
        associationBooklets={associationBooklets}
        selectedBooklet={selectedBooklet}
        onBookletChange={setSelectedBooklet}
        isMainAssociation={isMainAssociation}
      />
    </div>
  )
}

export default DashboardAssociationHome;
